import { useQuery } from "@apollo/client";
import { EyeIcon } from "@heroicons/react/24/outline";
import useNav from "../../../../hooks/useNavigation";
import { EventDetailsDocument } from "../../../../__generated__/graphql";
import { Sidebar } from "../../../Sidebar";
import Button from "../../../Button";
import EventDetails from "../../../EventDetails";

interface EventSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: string;
}

export default function EventSidebar({
  isOpen,
  onClose,
  eventId,
}: EventSidebarProps) {
  const navigateWithLog = useNav();
  const { data, loading, error } = useQuery(EventDetailsDocument, {
    variables: { eventId },
  });

  if (loading) return null;
  if (error) return <div>Error: {error.message}</div>;

  if (!data) return null;

  const event = data.event;

  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col justify-between gap-4 h-full">
        <div className="max-w-4xl">
          <EventDetails event={event} refetchProjectDetails={() => {}} />
        </div>

        <Button
          className="w-full gap-1"
          onClick={() => {
            navigateWithLog(`/events/${event?.id}`);
          }}
        >
          <EyeIcon className="w-4 h-4" />
          Voir plus
        </Button>
      </div>
    </Sidebar>
  );
}
